<app-modal-base
  [title]="dialogTitle"
  (onSubmitEvent)="onSubmit()"
  [loading]="formSubmitting"
  cancelType="CLOSE"
  [isDisabled]="shareForm.invalid"
>
  <ng-container main *ngTemplateOutlet="content"></ng-container>
  <ng-container footer *ngTemplateOutlet="footerContent"></ng-container>
</app-modal-base>

<ng-template #content>
  <div #container mat-dialog-content>
    <div class="formContainer d-flex justify-content-center">
      <div
        *ngIf="okMessage"
        class="alert alert-success alert-dismissible fade show text-center"
        role="alert"
      >
        {{ okMessage }}
      </div>
      <form [formGroup]="shareForm">
        <h5 class="d-inline col-2">À</h5>
        <div class="form-group row">
          <app-input
            [label]="emailTargetLabel"
            type="email"
            [formControl]="form_targetUserEmail"
            [size]="12"
            [autocompletionType]="autoCompletionType"
            [autocompletionHideNoResult]="true"
            [hasDeleteBtn]="false"
            displayType="email"
          ></app-input>
        </div>
        <ng-container *ngIf="!data.edition && canCreateTargetUserAccount">
          <div
            *ngIf="!targetUserHasAccount; else userAccountFound"
            class="form-group d-flex flex-column align-items-start"
          >
            <div class="form-group d-flex flex-row align-items-center">
              <mat-checkbox formControlName="createTargetUserAccount"
                >Créer le compte du destinataire</mat-checkbox
              >
              <a
                class="info-icon"
                (click)="showCreateUserInfo()"
                appTooltip="Plus d'informations"
              >
                <mat-icon
                  class="align-top"
                  color="primary"
                  aria-label="Plus d'informations"
                  >info</mat-icon
                >
              </a>
            </div>
            <div
              *ngIf="form_createTargetUserAccount.value"
              class="form-group row justify-content-center"
            >
              <div class="col-12 col-sm-6 col-md-4">
                <mat-form-field class="w-100">
                  <mat-label>Nom</mat-label>
                  <input
                    matInput
                    placeholder=""
                    type="text"
                    formControlName="targetUserName"
                  />
                  <mat-error>
                    <span *ngIf="form_targetUserName.hasError('required')"
                      >Veuillez saisir le nom</span
                    >
                    <span *ngIf="form_targetUserName.hasError('maxlength')"
                      >Le nom ne peut pas dépasser 60 caractères</span
                    >
                    <span *ngIf="form_targetUserName.hasError('badUserName')"
                      >Certains caractères sont invalides</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-12 col-sm-6 col-md-4">
                <mat-form-field class="w-100">
                  <mat-label>Prénom</mat-label>
                  <input
                    matInput
                    placeholder=""
                    type="text"
                    formControlName="targetUserFirstName"
                  />
                  <mat-error>
                    <span *ngIf="form_targetUserFirstName.hasError('required')"
                      >Veuillez saisir le prénom</span
                    >
                    <span *ngIf="form_targetUserFirstName.hasError('maxlength')"
                      >Le prénom ne peut pas dépasser 60 caractères</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
              <app-select
                class="col-12 col-sm-6 col-md-4"
                [label]="'userRole'"
                [formControl]="form_targetUserRole"
                [list]="createRoleList"
                [isEnum]="true"
                enumName="UserRole"
                [isMultiple]="false"
              ></app-select>
            </div>
          </div>
          <ng-template #userAccountFound>
            <div
              class="form-group d-flex justify-content-center align-items-center user-account-found"
            >
              <mat-icon color="accent">check</mat-icon> L'utilisateur existe sur
              EEMO.
            </div>
          </ng-template>
        </ng-container>
        <div
          *ngIf="!data.edition && canAddVisitMode"
          class="form-group d-flex flex-column align-items-start"
        >
          <div class="form-group d-flex flex-row align-items-center">
            <mat-checkbox formControlName="visitMode"
              >Activer l'option visite</mat-checkbox
            >
            <a
              *ngIf="!visitModeAvaiable"
              class="ml-2"
              mdbPopover="{{ visitModeUnavailableMessage.join('<br/>') }}"
              mdbPopoverTitle="Gestion des visites indisponible"
              trigger="focus"
              tabindex="0"
              ><mat-icon class="align-top" color="warn">warning</mat-icon></a
            >
            <a
              class="info-icon"
              (click)="showVisitModeInfo()"
              appTooltip="Plus d'informations"
            >
              <mat-icon
                class="align-top"
                color="primary"
                aria-label="Plus d'informations"
                >info</mat-icon
              >
            </a>
          </div>
        </div>
        <div
          *ngIf="
            !data.edition &&
            canAddVisitMode &&
            visitModeAvaiable &&
            form_visitMode.value
          "
          class="form-group d-flex flex-column align-items-start"
        >
          <div class="form-group d-flex flex-row align-items-center">
            <mat-checkbox formControlName="visitModeFull"
              >Demander la validation de l'ERP</mat-checkbox
            >
            <a
              class="info-icon"
              (click)="showVisitModeTypeInfo()"
              appTooltip="Plus d'informations"
            >
              <mat-icon
                class="align-top"
                color="primary"
                aria-label="Plus d'informations"
                >info</mat-icon
              >
            </a>
          </div>
        </div>
        <div class="form-group d-flex flex-row-reverse">
          <div *ngIf="!this.data.edition" class="ml-3">
            <button
              mat-mini-fab
              color="primary"
              type="button"
              [appTooltip]="getOptionsButtonText()"
              (click)="toogleAdvancedOptions()"
            >
              <mat-icon>{{
                showAdvancedOptions ? "expand_less" : "expand_more"
              }}</mat-icon>
            </button>
          </div>
          <div *ngIf="!showAdvancedOptions" class="mt-2">
            Accès en consultation pendant 1 mois.
          </div>
        </div>
        <ng-container *ngIf="showAdvancedOptions">
          <div>
            <div class="form-group row">
              <h5 class="d-inline col-12 col-md-4">Pour</h5>
              <mat-radio-group
                class="col-md-8"
                aria-label="Type de partage"
                formControlName="scope"
                (change)="scopeChanged($event)"
              >
                <mat-radio-button class="col-6" value="VIEWING"
                  >Consultation</mat-radio-button
                >
                <mat-radio-button class="col-6" value="DELEGATION"
                  >Délégation</mat-radio-button
                >
              </mat-radio-group>
            </div>
          </div>
          <div>
            <div class="form-group row">
              <h5 class="d-inline col-md-4">Les données</h5>
              <span class="d-flex align-items-center col-6 col-md-4 p-0">
                <mat-checkbox
                  #checkAllData
                  (change)="allDataChecked($event)"
                  [checked]="
                    !data.share ||
                    !data.share.allowedData ||
                    data.share.allowedData.length === 0
                  "
                  >Par défaut</mat-checkbox
                >
                <a
                  [class]="'info-icon' + (!isScopeViewing() ? ' hidden' : '')"
                  (click)="actionService.showViewDefaultRightInfo()"
                  appTooltip="Voir les données accessibles"
                >
                  <mat-icon
                    class="align-top"
                    color="primary"
                    aria-label="Voir les informations accessibles"
                    >info</mat-icon
                  >
                </a></span
              >
              <mat-checkbox
                class="col-6 col-md-4"
                #checkSelectData
                (change)="selectDataChecked($event)"
                [checked]="
                  data.share &&
                  data.share.allowedData &&
                  data.share.allowedData.length > 0
                "
                >Sélection
              </mat-checkbox>
              <mat-form-field class="offset-md-4 col-md-8 p-0">
                <mat-label>Choix des données</mat-label>
                <mat-select formControlName="allowedData" multiple>
                  <mat-option
                    *ngFor="let categ of sharingCategories"
                    [value]="categ"
                    >{{ sharingCategoryNames[categ] }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div *ngIf="!data.edition">
            <div class="form-group row">
              <h5 class="d-inline col-md-4">Pour une durée de</h5>
              <mat-form-field class="col-md-8">
                <mat-label>Durée</mat-label>
                <mat-select formControlName="duration" required placeholder="">
                  <mat-option
                    *ngFor="let duration of sharingHelper.getSharingDurations()"
                    [value]="duration"
                    >{{
                      sharingHelper.getSharingDurationName(duration)
                    }}</mat-option
                  >
                </mat-select>
                <mat-error>
                  <span *ngIf="form_duration.hasError('required')"
                    >Veuillez saisir une durée</span
                  >
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div *ngIf="data.edition">
            <div class="form-group row">
              <h5 class="d-inline col-md-4">Jusqu'à</h5>
              <div class="col-md-8">
                <mat-form-field class="col-md-6">
                  <mat-label>Date de fin</mat-label>
                  <input
                    *ngIf="isBrowserSupportsDateInput(); else datePicker"
                    matInput
                    placeholder=""
                    type="date"
                    formControlName="endDate"
                    nullValue
                  />
                  <ng-template #datePicker>
                    <input
                      class="w-75"
                      matInput
                      [matDatepicker]="picker"
                      required
                      formControlName="endDate"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="picker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </ng-template>
                  <mat-error>
                    <span *ngIf="form_endDate.hasError('futureDate')"
                      >La date de fin doit être dans le futur</span
                    >
                  </mat-error>
                </mat-form-field>
                <mat-checkbox
                  class="col-md-6"
                  #checkNoEndDate
                  (change)="noDateChanged($event)"
                  [checked]="!data.share.endDate"
                  >Pas d'expiration</mat-checkbox
                >
              </div>
            </div>
          </div>
          <div *ngIf="!data.edition" class="form-group row">
            <mat-form-field class="col-md-8 offset-md-2">
              <mat-label>Ajouter un message (optionnel)</mat-label>
              <textarea
                matInput
                placeholder=""
                type="text"
                formControlName="message"
              ></textarea>
              <mat-error>
                <span *ngIf="form_message.hasError('maxlength')"
                  >Le message ne peut pas dépasser 160 caractères</span
                >
              </mat-error>
            </mat-form-field>
          </div>
        </ng-container>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #footerContent>
  <div class="other-share">
    <mat-checkbox [formControl]="form_createAnotherShare"
      >Continuer avec un autre partage</mat-checkbox
    >
  </div>
</ng-template>
